import add from './Add'
import avatarMan from './AvatarMan'
import avatarWoman from './AvatarWoman'
import bookmark from './Bookmark'
import check from './Check'
import circle from './Circle'
import close from './Close'
import exportAction from './Export'
import eye from './Eye'
import eyeClosed from './EyeClosed'
import flag from './Flag'
import happy from './Happy'
import heart from './Heart'
import help from './Help'
import info from './Info'
import linkExternal from './LinkExternal'
import link from './Link'
import megaphone from './Megaphone'
import open from './Open'
import people from './People'
import refresh from './Refresh'
import reorder from './Reorder'
import reply from './Reply'
import sad from './Sad'
import search from './Search'
import settings from './Settings'
import share from './Share'
import spinner from './Spinner'
import star from './Star'
import start from './Start'
import tag from './Tag'
import tools from './Tools'
import trash from './Trash'
import volumeDown from './VolumeDown'
import volumeUp from './VolumeUp'
import warning from './Warning'

// ported from "video" category
import compress from './Compress'
import expand from './Expand'
import fastForward from './FastForward'
import minimize from './Minimize'
import pause from './Pause'
import playCircle from './PlayCircle'
import play from './Play'
import rewind from './Rewind'
import stepBack from './StepBack'
import stepForward from './StepForward'
import stop from './Stop'

export {
  add,
  avatarMan,
  avatarWoman,
  bookmark,
  check,
  circle,
  close,
  compress,
  expand,
  exportAction,
  eye,
  eyeClosed,
  fastForward,
  flag,
  happy,
  heart,
  help,
  info,
  link,
  linkExternal,
  megaphone,
  minimize,
  open,
  pause,
  people,
  play,
  playCircle,
  refresh,
  reorder,
  reply,
  rewind,
  sad,
  search,
  settings,
  share,
  spinner,
  star,
  start,
  stepBack,
  stepForward,
  stop,
  tag,
  tools,
  trash,
  volumeDown,
  volumeUp,
  warning,
}
